/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu'
import { LinqService, QueryOptions } from 'linquest'
import { OneOnOneMeetingDto, TeamOfManagerDto } from './models'

/**
 * OneOnOneMeetingApi - API class
 */
export class OneOnOneMeetingApi extends LinqService {
  /**
   * Creates a new OneOnOneMeetingApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider)
  }

  /**
   * @param dto
   */
  addOrUpdateAsync(dto?: OneOnOneMeetingDto, options?: QueryOptions) {
    // create query
    const url = `/OneOnOneMeeting/AddOrUpdateAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/OneOnOneMeeting/DeleteAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/OneOnOneMeeting/GetAsync`
    let query = this.createQuery<OneOnOneMeetingDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/OneOnOneMeeting/GetTranslatedAsync`
    let query = this.createQuery<OneOnOneMeetingDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/OneOnOneMeeting/List`
    let query = this.createQuery<OneOnOneMeetingDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/OneOnOneMeeting/ListTranslated`
    let query = this.createQuery<OneOnOneMeetingDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query
  }

  /**
   * @param dto
   */
  saveAsync(dto?: OneOnOneMeetingDto, options?: QueryOptions) {
    // create query
    const url = `/OneOnOneMeeting/SaveAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   */
  listMeetingsOfCurrentUser(options?: QueryOptions) {
    // create query
    const url = `/OneOnOneMeeting/ListMeetingsOfCurrentUser`
    let query = this.createQuery<OneOnOneMeetingDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query
  }

  /**
   * @param yearParams
   */
  listTeamMembersOfCurrentUser(options?: QueryOptions) {
    const url = `/OneOnOneMeeting/ListTeamMembersOfCurrentUser`
    let query = this.createQuery<TeamOfManagerDto[]>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   */
  ListMeetingsOfRelatedEmployee(toEmployeeId: string, options?: QueryOptions) {
    // create query
    const url = `/OneOnOneMeeting/ListMeetingsOfRelatedEmployee`
    let query = this.createQuery<OneOnOneMeetingDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.params.push({ key: 'toEmployeeId', value: toEmployeeId && toEmployeeId.toString() })

    query = query.withOptions(options)

    return query
  }
}
